const hasDomAccess =
  typeof window !== "undefined" && typeof document !== "undefined";

const initTabs = () => {
  if (!hasDomAccess) return;

  const tabParam = new URLSearchParams(window.location.search).get("tab");
  const initialTab = tabParam !== null && /^\d+$/.test(tabParam)
    ? Number(tabParam)
    : null;

  const tabLists = Array.from(
    document.querySelectorAll(".tab-label-list.js-tab")
  );
  const contentLists = Array.from(
    document.querySelectorAll(".tab-contents-list.js-tab-content")
  );
  if (!tabLists.length || !contentLists.length) return;

  const mobileQuery = window.matchMedia("(max-width: 768px)");
  const isMobile = () => mobileQuery.matches;
  const setActiveTabColor = (tabList) => {
    const activeTab = tabList.querySelector(".tab-label.is-active");
    const color = activeTab?.dataset?.tabColor || "";
    if (color) {
      tabList.style.setProperty("--tab-active-color", color);
    } else {
      tabList.style.removeProperty("--tab-active-color");
    }
  };
  const closeAllDropdowns = (exceptList = null) => {
    tabLists.forEach((list) => {
      if (list !== exceptList) {
        list.classList.remove("is-open");
      }
    });
  };

  const handleViewportChange = () => {
    if (!isMobile()) {
      closeAllDropdowns();
    }
  };
  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener("change", handleViewportChange);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(handleViewportChange);
  }

  document.addEventListener("click", (event) => {
    tabLists.forEach((tabList) => {
      if (!tabList.contains(event.target)) {
        tabList.classList.remove("is-open");
      }
    });
  });

  tabLists.forEach((tabList, listIdx) => {
    const contentList = contentLists[listIdx];
    if (!contentList) return;

    const tabs = Array.from(tabList.querySelectorAll(".tab-label"));
    const contents = Array.from(contentList.querySelectorAll(".tab-content"));
    const openDropdown = () => {
      closeAllDropdowns(tabList);
      tabList.classList.add("is-open");
    };
    const closeDropdown = () => tabList.classList.remove("is-open");

    tabList.addEventListener("click", (event) => {
      if (event.__tabSelectionCompleted) {
        return;
      }
      if (!isMobile() || tabList.classList.contains("is-open")) {
        return;
      }
      const clickedLabel = event.target.closest(".tab-label");
      if (!clickedLabel || clickedLabel.classList.contains("is-active")) {
        event.preventDefault();
        event.stopPropagation();
        openDropdown();
      }
    });

    const defaultIndex =
      initialTab !== null && initialTab < tabs.length && contents[initialTab]
        ? initialTab
        : tabs.findIndex((tab) => tab.classList.contains("is-active"));

    tabs.forEach((tab, i) => {
      const active = i === defaultIndex;
      tab.classList.toggle("is-active", active);
      contents[i]?.classList.toggle("is-active", active);
    });

    setActiveTabColor(tabList);

    tabs.forEach((tab, idx) => {
      tab.addEventListener("click", (event) => {
        if (isMobile() && !tabList.classList.contains("is-open")) {
          event.preventDefault();
          event.stopPropagation();
          openDropdown();
          return;
        }

        tabs.forEach((t, i) => {
          const active = i === idx;
          t.classList.toggle("is-active", active);
          contents[i]?.classList.toggle("is-active", active);
        });
        setActiveTabColor(tabList);

        if (isMobile()) {
          closeDropdown();
          event.__tabSelectionCompleted = true;
        }
      });
    });
  });
};

export { initTabs as default };
